import { LibertyOpeningPhasePanel } from "./liberty/LibertyOpeningPhasePanel";
import { PublicLeadSection } from "./PublicLeadSection";

export function PublicMembershipInterestPage({
  currentMember,
  leadForm,
  leadSubmitted,
  leadInterestOptions,
  libertyPublic,
  memberPortalHref,
  onCreateLead,
  onLeadFormChange,
  publicContactEmail,
  publicContactPhone,
  range,
  rangeStory,
  reservationResources,
  submittingLead,
  workspaceLabel
}) {
  return (
    <>
      <section className="public-membership-page-intro">
        <div>
          <span className="public-section-kicker">Membership updates</span>
          <h2 id="membership">Membership updates</h2>
          <p>
            {libertyPublic
              ? "Membership details are being finalized. Send your contact information and the range will follow up before opening."
              : `Send your contact information and the ${workspaceLabel} team will follow up when memberships are ready.`}
          </p>
        </div>
        {libertyPublic && (
          <dl>
            <div>
              <dt>Membership model</dt>
              <dd>Family memberships for spouses and children</dd>
            </div>
            <div>
              <dt>Opening plan</dt>
              <dd>Phased access as finished range areas come online</dd>
            </div>
            <div>
              <dt>Next step</dt>
              <dd>Share your contact information for opening updates</dd>
            </div>
          </dl>
        )}
      </section>

      {libertyPublic && (
        <>
          <section className="public-range-story public-membership-context" aria-label="Membership access context">
            {rangeStory.map((item) => (
              <article key={item.title}>
                <strong>{item.title}</strong>
                <span>{item.body}</span>
              </article>
            ))}
          </section>
          <LibertyOpeningPhasePanel
            range={range}
            resources={reservationResources}
            variant="membership"
          />
        </>
      )}

      {currentMember?.status === "active" && (
        <div className="public-requirements-panel">
          <h3>Your membership is already active</h3>
          <p>Use the member portal for class registration, payments, documents, and support instead of starting a duplicate membership request.</p>
          <a className="public-primary-action" href={memberPortalHref}>
            Open member portal
          </a>
        </div>
      )}

      <PublicLeadSection
        body={libertyPublic
          ? "For membership information please enter your contact information here to be contacted before we open."
          : `Share your contact information and the ${workspaceLabel} team will follow up with the right membership path.`}
        contactEmail={publicContactEmail}
        contactPhone={publicContactPhone}
        form={leadForm}
        interestOptions={leadInterestOptions}
        kicker={libertyPublic ? "Get contacted with updates" : "Membership updates"}
        onChange={onLeadFormChange}
        onSubmit={onCreateLead}
        submitted={leadSubmitted}
        submitting={submittingLead}
        title={libertyPublic ? "Sign up to be notified before we open!" : "Ask for membership details"}
        workspaceLabel={workspaceLabel}
      />
    </>
  );
}
